import { createSelector } from "reselect";
import { getters as FormGetters } from "ui-kit/Form/model";
import * as R from "ramda";
import Helpers from "utils/Global/Helpers";
import { FORM_ID } from "./constants";

export const disabledSaveButton = createSelector(
  state =>
    FormGetters.fields(state, {
      instanceId: FORM_ID
    }),
  fields => {
    const name = R.pathOr(null, ["firstName", "value"], fields);
    const lastName = R.pathOr(null, ["lastName", "value"], fields);
    const email = R.pathOr(null, ["email", "value"], fields);
    return (
      R.isEmpty(R.trim(name ?? "")) ||
      R.isEmpty(R.trim(lastName ?? "")) ||
      R.isEmpty(R.trim(email ?? "")) ||
      !Helpers.isValidEmail(email)
    );
  }
);

export const isEmailValid = createSelector(
  state =>
    FormGetters.fields(state, {
      instanceId: FORM_ID
    }),
  fields => {
    const email = R.pathOr("", ["email", "value"], fields);
    if (!email.length) return true;
    return Helpers.isValidEmail(email);
  }
);
